import React from "react";

const MissionVision = () => {
  return (
    <div className="sis-our-mision-and-vision-section sis-comman-bg sis-br-radius mt-3 section">
      <div className="container">

        {/* =========================================
            SECTION HEADING
        ========================================== */}
        <div className="row align-items-center">

          <div className="col-lg-9">

            <div className="sisf-sis-section-title sis-section-title">

              <span className="sisf-m-subtitle sis-text-anime-style-3">
                MISSION &amp; VISION
              </span>

              <h2 className="sisf-m-title sis-text-anime-style-3">
                Making Every Journey Comfortable, Reliable &amp;
                Convenient with CitySky Cabs
              </h2>

              <div
                className="sisf-m-text"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <p>
                  CitySky Cabs is committed to providing dependable cab
                  services in Pune for local travel, airport transfers,
                  corporate transportation, outstation journeys, family
                  tours and group travel. Our focus is to make cab booking
                  simple while providing comfortable vehicles and
                  professional travel assistance for every journey.
                </p>
              </div>

            </div>

          </div>


          {/* =========================================
              FLEET BUTTON
          ========================================== */}
          <div className="col-lg-3 text-end">

            <div className="sisf-sis-section-title sis-section-title">

              <div
                className="sisf-m-button"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <a
                  href="/fleets"
                  className="sis-btn-default"
                >
                  Explore Our Fleet

                  <i className="fa-solid fa-arrow-right-long"></i>
                </a>
              </div>

            </div>

          </div>

        </div>


        {/* =========================================
            MISSION / VISION CONTENT
        ========================================== */}
        <div className="row">

          {/* =====================================
              OUR MISSION
          ====================================== */}
          <div className="col-lg-4 col-md-6">

            <div
              className="sisf-our-mission-content bg-white sis-radius p-3"
              data-aos="fade-up"
              data-aos-delay="100"
            >

              <div className="sis-e-inner">

                {/* ICON */}
                <div className="sisf-our-icon">

                  <figure>
                    <img
                      src="/images/our-icon1.svg"
                      alt="CitySky Cabs Mission"
                    />
                  </figure>

                </div>


                {/* CONTENT */}
                <div className="sisf-e-content">

                  <div className="sis-e-title mb-2">
                    <h3>
                      Our Mission
                    </h3>
                  </div>

                  <div className="sis-e-text">
                    <p>
                      Our mission is to provide reliable, comfortable and
                      convenient cab rental services that make local and
                      outstation travel easier for individuals, families
                      and businesses.
                    </p>
                  </div>

                </div>


                {/* MISSION POINTS */}
                <div className="sisf-sis-listing-items sis-comman-bg sis-radius p-3">

                  <p className="mb-2">

                    <span>
                      <i className="fa-solid pe-3 fa-check"></i>
                    </span>

                    <span>
                      Easy and convenient cab booking
                    </span>

                  </p>


                  <p className="mb-2">

                    <span>
                      <i className="fa-solid pe-3 fa-check"></i>
                    </span>

                    <span>
                      Comfortable and reliable transportation
                    </span>

                  </p>


                  <p className="mb-2">

                    <span>
                      <i className="fa-solid pe-3 fa-check"></i>
                    </span>

                    <span>
                      Professional drivers for every journey
                    </span>

                  </p>


                  <p className="mb-0">

                    <span>
                      <i className="fa-solid pe-3 fa-check"></i>
                    </span>

                    <span>
                      Well-maintained vehicles for different trips
                    </span>

                  </p>

                </div>

              </div>

            </div>

          </div>


          {/* =====================================
              OUR VISION
          ====================================== */}
          <div className="col-lg-4 col-md-6">

            <div
              className="sisf-our-mission-content bg-white page sis-radius p-3"
              data-aos="fade-up"
              data-aos-delay="300"
            >

              <div className="sis-e-inner">

                {/* ICON */}
                <div className="sisf-our-icon">

                  <figure>
                    <img
                      src="/images/our-icon2.svg"
                      alt="CitySky Cabs Vision"
                    />
                  </figure>

                </div>


                {/* CONTENT */}
                <div className="sisf-e-content">

                  <div className="sis-e-title mb-2">
                    <h3>
                      Our Vision
                    </h3>
                  </div>

                  <div className="sis-e-text">
                    <p>
                      Our vision is to make CitySky Cabs a dependable
                      choice for cab rental in Pune by offering convenient
                      booking, suitable vehicle options and consistent
                      service for different travel requirements.
                    </p>
                  </div>

                </div>


                {/* VISION POINTS */}
                <div className="sisf-sis-listing-items sis-comman-bg sis-radius p-3">

                  <p className="mb-2">

                    <span>
                      <i className="fa-solid pe-3 fa-check"></i>
                    </span>

                    <span>
                      Reliable cab service across Pune
                    </span>

                  </p>


                  <p className="mb-2">

                    <span>
                      <i className="fa-solid pe-3 fa-check"></i>
                    </span>

                    <span>
                      Multiple vehicle options for every journey
                    </span>

                  </p>


                  <p className="mb-2">

                    <span>
                      <i className="fa-solid pe-3 fa-check"></i>
                    </span>

                    <span>
                      Local, airport, corporate &amp; outstation travel
                    </span>

                  </p>


                  <p className="mb-0">

                    <span>
                      <i className="fa-solid pe-3 fa-check"></i>
                    </span>

                    <span>
                      Convenient travel support for every booking
                    </span>

                  </p>

                </div>

              </div>

            </div>

          </div>


          {/* =====================================
              RIGHT IMAGE + SUPPORT
          ====================================== */}
          <div className="col-lg-4 col-md-6">

            {/* IMAGE */}
            <div className="sisf-our-mission-right-image mb-4 pb-2">

              <figure className="sis-image-anime sis-reveal">

                <img
                  src="/images/ertiga.png"
                  className="w-100 sis-radius"
                  alt="CitySky Cabs Cab Rental Service in Pune"
                />

              </figure>

            </div>


            {/* =====================================
                CUSTOMER SUPPORT CARD
            ====================================== */}
            <div
              className="sisf-our-mission-content-bottom sis-primary-background sis-radius position-relative p-4"
              data-aos="fade-up"
              data-aos-delay="300"
            >

              {/* DECORATIVE IMAGE */}
              <div
                className="sisf-sis-top-right-image"
                data-aos="fade-left"
                data-aos-delay="700"
              >

                <figure>
                  <img
                    src="/images/tyer-bg.png"
                    alt=""
                  />
                </figure>

              </div>


              <div className="sis-e-inner">

                {/* 24/7 */}
                <div className="sis-counter-item">

                  <div className="sis-counter-title">

                    <h2 className="d-flex align-items-center">

                      <span className="sis-counter text-white">
                        24
                      </span>

                      <span className="sisf-digit-label text-white">
                        × 7
                      </span>

                    </h2>

                  </div>


                  <div className="sis-counter-content">

                    <span className="sisf-content text-white">
                      Cab Booking Assistance
                    </span>

                  </div>

                </div>


                {/* SUPPORT TEXT */}
                <div className="sisf-bottom-text mt-4">

                  <p className="text-white mb-0">
                    Connect with CitySky Cabs for local, airport,
                    corporate and outstation cab booking assistance
                    in Pune.
                  </p>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
  );
};

export default MissionVision;